'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const ModalDialogContext = createContext(null);
ModalDialogContext.displayName = 'ModalDialogContext';
function useModalDialogContext() {
    return useNonNullishContext(ModalDialogContext);
}

export { ModalDialogContext, useModalDialogContext };
